<template>
  <div>
    <ts-loading-banner :loading="loading">
      <ts-card>
        <ts-card-wrapper>
          <div class="ts-flex ts-space-x-3 ts-items-end">
            <div>
              <label>{{ $t('tracking.dateRange') }}</label>
              <a-range-picker
                v-model="model.dateRange"
                :allowClear="false"
                format="DD-MM-YYYY HH:mm:ss"
                valueFormat="DD-MM-YYYY HH:mm:ss"
                :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
              />
            </div>
            <div class="ts-w-64">
              <label>{{ $t('tracking.employee') }}</label>
              <a-select
                class="ts-w-64"
                v-model="model.employee_id"
                :options="employees"
                showSearch
                :filterOption="filterOption"
                :placeholder="$t('tracking.employee')"
              ></a-select>
              <div class="ts-text-red-600" v-if="errors.has('employee_id')">
                {{ errors.first('employee_id') }}
              </div>
            </div>
            <div class="ts-w-full">
              <label>{{ $t('tracking.remark') }}</label>
              <input
                v-model.trim="updateData.remark"
                type="text"
                class="form-control"
                :placeholder="$t('tracking.remark')"
              />
              <div class="ts-text-red-600" v-if="errors.has('remark')">
                {{ errors.first('remark') }}
              </div>
            </div>
            <ts-button
              color="primary"
              @click.prevent="onUpdateRemark"
              class="ts-h-8"
              >{{ isUpdate ? $t('update') : $t('add') }}</ts-button
            >
            <ts-button
              color="primary"
              outline
              @click.prevent="fetchLocation"
              class="ts-h-8"
              >{{ $t('view') }}</ts-button
            >
          </div>
          <div class="ts-mt-3 ts-overflow-y-scroll" style="max-height: 300px;">
            <table class="ts-w-full">
              <thead>
                <tr class="ts-bg-gray-100 ts-sticky ts-z-30 ts-top-0">
                  <th class="ts-uppercase ts-px-2 ts-py-1">
                    <ts-checkbox
                      :checkedValue="isCheckAll"
                      @change="onCheckAll"
                    />
                  </th>
                  <th class="ts-uppercase ts-px-2 ts-py-1">Date Time</th>
                  <th class="ts-uppercase ts-px-2 ts-py-1">Lat & Long</th>
                  <th class="ts-uppercase ts-px-2 ts-py-1">Distance</th>
                  <th class="ts-uppercase ts-px-2 ts-py-1">User Name</th>
                  <th class="ts-uppercase ts-px-2 ts-py-1">User Remark</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(resource, index) in resources"
                  :key="index"
                  :class="{ 'ts-bg-blue-100': resource.remark }"
                >
                  <td class="ts-px-2 ts-py-1">
                    <ts-checkbox
                      v-model="updateData.ids"
                      :value="resource.id"
                    />
                  </td>
                  <td class="ts-px-2 ts-py-1">
                    {{ resource.tracking_time }}
                  </td>
                  <td class="ts-px-2 ts-py-1">
                    {{ resource.lat + ' ' + resource.lng }}
                  </td>
                  <td class="ts-px-2 ts-py-1">
                    {{ displayDistance(index) }}
                  </td>
                  <td class="ts-px-2 ts-py-1">
                    {{ resource.employee_name_en }}
                  </td>
                  <td class="ts-px-2 ts-py-1">{{ resource.remark }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </ts-card-wrapper>
        <gmap-map
          ref="gmap"
          :center="center"
          :zoom="13"
          style="width:100%;  height: calc(100vh - 103px)"
        >
          <gmap-polyline
            v-if="!loading"
            :path="plPath"
            :options="{ geodesic: true, strokeColor: '#FF0000' }"
          >
          </gmap-polyline>

          <gmap-marker
            v-if="startPoint"
            title="Start"
            :position="startPoint"
            :icon="{
              url: startIcon,
              scaledSize: { width: 35, height: 35 }
            }"
          />
          <gmap-marker
            v-if="endPoint"
            title="End"
            :position="endPoint"
            :icon="{
              url: parkingIcon,
              scaledSize: { width: 30, height: 45 }
            }"
          />

          <gmap-marker
            v-for="(s, index) in markers"
            :key="index"
            :position="{
              lat: s.lat,
              lng: s.lng
            }"
            :icon="{
              url: icon,
              scaledSize: { width: 35, height: 35 },
              labelOrigin: {
                x: 30,
                y: -2
              }
            }"
          />
          <gmap-info-window
            v-for="(win, index) in markers"
            :options="{
              maxWidth: 400,
              pixelOffset: { width: 0, height: -35 }
            }"
            :position="{
              lat: win.lat,
              lng: win.lng
            }"
            :opened="true"
          >
            <div>
              <b>{{ win.tracking_time }}</b>
            </div>
          </gmap-info-window>
        </gmap-map>
      </ts-card>
    </ts-loading-banner>
  </div>
</template>
<script>
import startIcon from '@/assets/marker/start-icon.svg'
import parkingIcon from '@/assets/marker/point.svg'
import icon from '@/assets/marker/people-location.svg'
import moment from 'moment'
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import calDistance from './calDistance'

export default {
  name: 'locationPath',
  data() {
    return {
      icon,
      loading: false,
      resources: [],
      startIcon,
      parkingIcon,
      plPath: [],
      employees: undefined,
      startPoint: undefined,
      endPoint: undefined,
      center: { lng: 105.57359185298843, lat: 12.291513194851614 },
      errors: new Errors(),
      model: {
        dateRange: [
          moment()
            .startOf('days')
            .format('DD-MM-YYYY HH:mm:ss'),
          moment()
            .endOf('days')
            .format('DD-MM-YYYY HH:mm:ss')
        ],
        employee_id: undefined,
        remark_id: undefined
      },
      updateData: {
        id: '',
        remark: '',
        ids: []
      }
    }
  },
  created() {
    this.fetchEmployee()
  },
  computed: {
    isCheckAll() {
      return this.updateData.ids.length === this.resources
    },
    isUpdate() {
      const { employee_id, min_date, max_date } = this.$route.query
      return (
        employee_id !== undefined &&
        min_date !== undefined &&
        max_date !== undefined
      )
    },
    markers() {
      return this.resources.filter(u => this.updateData.ids.includes(u.id))
    }
  },
  methods: {
    moment,
    ...mapActions('sale/locationTracking', ['getEmployee', 'fetch']),
    ...mapActions('sale/locationTrackingRemark', ['store']),
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    async fetchLocation() {
      this.loading = true
      this.startPoint = undefined
      this.endPoint = undefined
      this.plPath = []
      this.resources = []
      this.errors = new Errors()
      return this.fetch(this.model)
        .then(response => {
          if (response.data.length) {
            this.resources = response.data
            const first = response.data[0]
            const last = response.data[response.data.length - 1]
            this.center.lat = parseFloat(first.lat, 10)
            this.center.lng = parseFloat(first.lng, 10)
            this.startPoint = this.center
            this.endPoint = {
              lat: parseFloat(last.lat, 10),
              lng: parseFloat(last.lng, 10)
            }
            for (let i = 0; i < response.data.length; i++) {
              this.plPath.push({
                lat: parseFloat(response.data[i].lat, 10),
                lng: parseFloat(response.data[i].lng, 10)
              })
            }
          }
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.loading = false))
    },
    fetchEmployee() {
      this.loading = true
      this.getEmployee()
        .then(async employee => {
          this.employees = employee.data.map(el => ({
            value: el.employee_id,
            label: el.employee_name_kh + ' ' + el.employee_name_en
          }))

          const {
            employee_id,
            min_date,
            max_date,
            remark_id
          } = this.$route.query

          if (employee_id && min_date && max_date) {
            this.model.employee_id = parseInt(employee_id)
            this.model.remark_id = parseInt(remark_id)
            this.model.dateRange = [
              moment(min_date, 'DD-MM-YYYY HH:mm:ss').format(
                'DD-MM-YYYY HH:mm:ss'
              ),
              moment(max_date, 'DD-MM-YYYY HH:mm:ss').format(
                'DD-MM-YYYY HH:mm:ss'
              )
            ]
            await this.fetchLocation()
            this.updateData.id = remark_id
            this.updateData.remark = this.resources[0].remark
            this.updateData.dateRange = [min_date, max_date]
            this.updateData.ids = this.resources.map(el => el.id)
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    displayDistance(index) {
      if (index === 0) {
        return 0
      }
      if (index + 1 < this.resources.length) {
        const current = this.resources[index]
        const next = this.resources[index + 1]

        const distance = calDistance(
          current.lat,
          current.lng,
          next.lat,
          next.lng
        )

        return distance.toFixed(2) + ' Meters'
      }

      return 0
    },
    onUpdateRemark() {
      this.loading = true
      this.store({
        id: this.updateData.id,
        remark: this.updateData.remark,
        ids: this.updateData.ids,
        employee_id: this.model.employee_id
      })
        .then(response => {
          this.$toasted.success(response.message)
          if (this.isUpdate) {
            this.$router.go(-1)
          }
          this.clearInput()
          this.fetchLocation()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.loading = false))
    },
    clearInput() {
      this.updateData.remark = ''
      this.updateData.ids = []
      this.model.remark_id = undefined
    },
    onCheckAll(value) {
      if (value) {
        this.updateData.ids = this.resources.map(el => el.id)
        return
      }
      this.updateData.ids = []
    }
  }
}
</script>
<style>
.gm-ui-hover-effect {
  opacity: 0.6;
  display: none !important;
}
</style>
